import { useEffect } from 'react';
import { clearAllToasts, signalSessionEnded } from './toastStore';

/**
 * Session-scopes the module-level toast store: clears every toast (and halts
 * all dwell timers) whenever the session is signed out. Sign-out is a
 * client-side state flip, not a reload — without this, an error toast
 * carrying tenant data (errors never auto-dismiss) would survive sign-out and
 * paint over the login screen / into the next sign-in on a shared device
 * (the 2026-07-01 BulkRunDock confidentiality-on-glass class; see the
 * session-scoping standing rule in CLAUDE.md).
 *
 * Injected `signedIn` (not useAuth() internally) to mirror the
 * BulkRunProvider / LifecycleActivationProvider pattern — keeps the hook
 * decoupled and unit-testable. Runs on mount too: clearing an empty store
 * while signed out is a harmless no-op.
 */
export default function useSessionToastReset(signedIn) {
  // Render phase on purpose: pending notice clears must be DROPPED before the
  // session-keyed tree unmounts (its cleanup flush runs before any effect).
  if (!signedIn) signalSessionEnded();
  useEffect(() => {
    if (!signedIn) clearAllToasts();
  }, [signedIn]);
}
